import { processSteps } from '@/data/sponsor/process';

const ProcessSection = () => {
  return (
    <div className="py-16 bg-background">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-3xl lg:text-4xl font-bold text-foreground mb-6">
            Launch SeniorThrive With Your Top Clients
          </h2>
          <p className="text-lg text-muted-foreground max-w-3xl mx-auto">
            A structured process designed for seamless integration into your existing client relationships.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 max-w-6xl mx-auto">
          {processSteps.map((step, index) => (
            <div key={index} className="text-center">
              <div className="w-16 h-16 bg-primary rounded-full flex items-center justify-center mx-auto mb-6">
                <span className="text-xl font-bold text-primary-foreground">{step.number}</span>
              </div>
              <h3 className="text-lg font-bold text-foreground mb-3">
                {step.title}
              </h3>
              <p className="text-muted-foreground leading-relaxed text-sm">
                {step.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ProcessSection;
